@if (inTable) {
  @for (
    alternative of question.alternatives;
    track altIndex;
    let altIndex = $index
  ) {
    <td
      [formGroup]="formGroup"
      class="align-middle"
      [class.second-column-start]="secondColumnStart && altIndex === 0"
      [attr.headers]="
        rowTitle && colGroupTitle
          ? rowTitle +
            ' ' +
            (colGroupTitle | toValidId) +
            ' ' +
            ((alternative.title | toValidId) +
              (columnIdSuffix ? '-' + columnIdSuffix : ''))
          : rowTitle
            ? rowTitle +
              ' ' +
              ((alternative.title | toValidId) +
                (columnIdSuffix ? '-' + columnIdSuffix : ''))
            : undefined
      "
    >
      <div class="flex justify-center items-center w-full">
        <div
          class="flex flex-row items-center"
          [ngClass]="
            isOtherSelected && alternative.type === 'OTHER'
              ? 'border-[1.5px] border-solid border-border-gray rounded'
              : 'gap-2'
          "
        >
          <div
            class="min-w-14 min-h-12 flex items-center justify-center"
            [ngClass]="{
              'pb-2': isOtherSelected && alternative.type === 'OTHER',
            }"
          >
            @if (alternative.id) {
              <div
                class="qb-checkbox qb-checkbox-outline flex items-center justify-center"
              >
                <input
                  title="{{ question.title | stripHtml }} {{
                    columnTitle ? '- ' + (columnTitle | stripHtml) + ' ' : ''
                  }}- {{ alternative.title | stripHtml }}"
                  [id]="alternative.id"
                  [formControlName]="alternative.id"
                  [value]="
                    alternative.type === 'OTHER'
                      ? alternative.id
                      : alternative.title
                  "
                  [attr.name]="question.id"
                  [name]="question.id"
                  [attr.aria-disabled]="
                    !!disabledCheckboxes[alternative.id] ||
                    formGroup.get(alternative.id)?.disabled
                  "
                  [ngClass]="{
                    'opacity-70':
                      disabledCheckboxes[alternative.id] ||
                      formGroup.get(alternative.id)?.disabled,
                  }"
                  (change)="onChange(alternative.id, alternative.type)"
                  (click)="
                    disabledCheckboxes[alternative.id]
                      ? onDisabledCheckboxClick()
                      : null
                  "
                  type="checkbox"
                  class="min-w-8 transition-transform-slow lg:hover:scale-125"
                  [style.cursor]="
                    !!disabledCheckboxes[alternative.id] ||
                    formGroup.get(alternative.id)?.disabled
                      ? 'not-allowed'
                      : 'pointer'
                  "
                  [attr.value]="
                    alternative.type === 'OTHER'
                      ? alternative.id
                      : alternative.title
                  "
                />
              </div>
            }
          </div>

          <span class="sr-only" id="label-{{ alternative.id }}">{{
            question.title + alternative.title
          }}</span>
          @if (
            (isOtherSelected && otherControl && alternative.type === "OTHER") ||
            (question.inPrintView && alternative.type === "OTHER")
          ) {
            <div class="min-w-40 pt-2">
              <textarea
                #otherTextarea
                class="bg-inherit w-full resize-none focus:outline-none"
                rows="1"
                [id]="question.id + '-other-input'"
                [formControl]="otherControl"
                [attr.aria-label]="
                  'question.singleselect.otherinputlabel' | translate
                "
                [ngClass]="{
                  'pr-9': otherControl.invalid && otherControl.touched,
                }"
              ></textarea>
              @if (otherControl.invalid && otherControl.touched) {
                <app-icon
                  [name]="Icon.Warning"
                  class="relative float-right bottom-[1.8rem] w-max validation-dynamic-theme"
                ></app-icon>
              }
              <div class="flex justify-between">
                <div class="text-xs">
                  @if (
                    otherControl.hasError("maxLength") && otherControl.touched
                  ) {
                    <app-validator
                      [question]="question"
                      [validator]="ValidatorType.MaxLength"
                      [control]="otherControl"
                    ></app-validator>
                  }
                </div>
                <p
                  class="text-xs pl-2 pr-2 pt-0"
                  [ngClass]="{
                    'validation-dynamic-theme':
                      otherControl.value?.length > 255,
                    '-mr-6': otherControl.invalid && otherControl.touched,
                  }"
                >
                  <span aria-hidden="true">
                    {{ otherControl.value?.length ?? 0 }}/255</span
                  >
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    </td>
  }
  @if (statusMessage) {
    <p
      #statusMessageRef
      role="status"
      aria-live="polite"
      tabindex="-1"
      class="status-message flex items-center gap-2 mt-2 validation-dynamic-theme min-w-20"
    >
      <app-icon
        [name]="Icon.Info"
        class="w-6 h-6 flex-shrink-0"
        [attr.aria-label]="'validation.general.info' | translate"
      ></app-icon>
      <span>{{ statusMessage }}</span>
    </p>
  }
}
@if (!inTable) {
  @if (inMobileAndMatrix) {
    <app-multi-select-input
      [question]="question"
      [formGroup]="formGroup"
      [otherControl]="otherControl"
      [isOtherSelected]="isOtherSelected"
      [onChange]="onChange"
      [onDisabledCheckboxClick]="onDisabledCheckboxClick.bind(this)"
      [hasFormGroupBeenTouched]="hasFormGroupBeenTouched"
      [statusMessage]="statusMessage"
      [disabledCheckboxes]="disabledCheckboxes"
      [columnTitle]="columnTitle"
      [quotaErrorAlternativeIds]="getQuotaErrorsForAlternatives()"
    ></app-multi-select-input>
  } @else {
    <app-question-base
      [question]="question"
      [isFirstQuestion]="isFirstQuestion"
      (focusout)="onFocusOut($event)"
    >
      <app-multi-select-input
        [question]="question"
        [formGroup]="formGroup"
        [otherControl]="otherControl"
        [isOtherSelected]="isOtherSelected"
        [onChange]="onChange"
        [onDisabledCheckboxClick]="onDisabledCheckboxClick.bind(this)"
        [hasFormGroupBeenTouched]="hasFormGroupBeenTouched"
        [statusMessage]="statusMessage"
        [disabledCheckboxes]="disabledCheckboxes"
        [columnTitle]="columnTitle"
        [quotaErrorAlternativeIds]="getQuotaErrorsForAlternatives()"
      ></app-multi-select-input>
    </app-question-base>
  }
}
